import { CourseView } from "components/materials/course/content/CourseView";

export default function Page() {
  return <CourseView />;
}
